import { render, staticRenderFns } from "./OrgDetails.vue?vue&type=template&id=47e1c2af&"
import script from "./OrgDetails.vue?vue&type=script&lang=js&"
export * from "./OrgDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetails.vue?vue&type=style&index=0&id=47e1c2af&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports